<script lang="ts" setup>
    import HeroMedia from '~/components/heroElements/HeroMedia.vue';
    import NephrologyHeroBackgroundAnimated from '~/components/nephrology/Hero/NephrologyHeroBackgroundAnimated.vue';

    const props = defineProps<{ blok: HeroComponentStoryblok }>();
    const { headlineContent, asset, mediaSrc, mediaAlt, mediaContentType } = useHeroComponentContent(() => props.blok);
</script>

<template>
    <div
        v-editable="props.blok"
        class="hero-container"
    >
        <NephrologyHeroBackgroundAnimated />
        <HeroMedia
            :media="asset"
            :src="mediaSrc"
            :alt="mediaAlt"
            :content-type="mediaContentType"
            storage-key="nephrology-hero-paused"
            variant="nephrology"
        />

        <div class="hero-wrapper">
            <div class="content">
                <!-- eslint-disable vue/no-v-html -->
                <div
                    class="headline"
                    v-html="headlineContent"
                />
                <!-- eslint-enable vue/no-v-html -->

                <div
                    v-if="props.blok.button"
                    class="btn-wrapper"
                >
                    <ButtonLink
                        v-for="item in props.blok.button"
                        :key="item._uid"
                        :blok="item"
                    />
                </div>
            </div>
        </div>

        <HeroScrollDown />
    </div>
</template>

<style lang="scss" scoped>
    /* use for now urology hero section style
    /* TODO: needs to be refactored into one shared Hero with embedded css.
     * style deviations should be streamlined in both hero sections.
     */
    @import '~/assets/scss/urology/urology-hero-section.scss';

    /* override urology hero section style */
    .hero-container {
        .hero-wrapper {
            .content {
                .btn-wrapper {
                    --btn-primary-bg: unset;
                    --btn-primary-bg-hover: inherit;
                    --btn-primary-fg: inherit;

                    :deep(span) {
                        font-weight: inherit;
                    }
                }
            }
        }
    }
</style>
